import Header from "../../components/shared/Header";
import AboutUs from "./AboutUs";
import Agents from "./Agents";
import ContactUs from "./ContactUs";
import FAQ from "./FAQ";
import Hero from "./Hero";
import KeyFeatures from "./KeyFeatures";
import Roadmap from "./Roadmap";
import Footer from "../../components/shared/Footer";

import "./Home.scss";
import Decoration1Img from "../../assets/images/deocration/decoration-1.png";
import Decoration5Img from "../../assets/images/deocration/decoration-5.png";

export default function Home() {
	return (
		<>
			<Header />

			<Hero />

			<AboutUs />

			<div className="home-decoration-1 decoration">
				<img src={Decoration1Img} alt="decoration" />
			</div>

			<KeyFeatures />

			<div className="home-decoration-2 decoration">
				<img src={Decoration1Img} alt="decoration" />
			</div>

			<Agents />

			<div className="home-decoration-3 decoration">
				<img src={Decoration5Img} alt="decoration" />
			</div>

			<Roadmap />

			<FAQ />

			<ContactUs />

			<Footer />
		</>
	);
}
